<div class="transition-card-container">
    <div class="transition-card">
        <section class="transition-card__content">
            <header class="transition-card__header">
                <h1 class="transition-card__heading">{{headerText}}</h1>
                <div *ngIf="!isProcessing" class="transition-card__divider"></div>
            </header>
            <div class="transition-card__body">
                <div *ngIf="isProcessing" class="transition-card__spinner-container">
                    <img class="transition-card__spinner" src="/img/components/transition-card/loading-spinner-white.gif"/>
                    <p class="transition-card__spinner-text">{{processText}}</p>
                </div>
                <p class="transition-card__body-text" [innerHTML]="bodyText"></p>
                <p *ngIf="showDeclinedCTA" class="transition-card__body-text">
                    Our decision was based on the proposed insured’s health history and the guidelines for this policy.
                    If you would like to learn more details, please email
                    <a class="text-link" href="mailto:SupportDirectTerm@massmutual.com">SupportDirectTerm@massmutual.com</a>
                    with your name and policy number <ng-container *ngIf="policyNumber">({{policyNumber}})</ng-container>
                    and we can provide further explanation within 1-5 business days.
                </p>
                <p *ngIf="showRejectedCTA" class="transition-card__body-text">
                    We could not verify your {{rejectedCause}} based on what you provided.
                    If you would like to learn more details, please email
                    <a class="text-link" href="mailto:SupportDirectTerm@massmutual.com">SupportDirectTerm@massmutual.com</a>
                    with your name and policy number <ng-container *ngIf="policyNumber">({{policyNumber}})</ng-container>
                    and we can provide further explanation within 1-5 business days.
                </p>
                <p *ngIf="showTerminatedCTA" class="transition-card__body-text">
                    You will have coverage through the end of your current payment period.
                    If you would like to learn more details, please email
                    <a class="text-link" href="mailto:SupportDirectTerm@massmutual.com">SupportDirectTerm@massmutual.com</a>
                    with your name and policy number <ng-container *ngIf="policyNumber">({{policyNumber}})</ng-container>
                    and we can provide further explanation within 1-5 business days.
                </p>
                <p *ngIf="showContactCTA" class="transition-card__body-text">
                    If you would like to learn more details, please email
                    <a class="text-link" href="mailto:SupportDirectTerm@massmutual.com">SupportDirectTerm@massmutual.com</a>
                    with your name and policy number <ng-container *ngIf="policyNumber">({{policyNumber}})</ng-container>
                    and we can provide further explanation within 1-5 business days.
                </p>
                <p *ngIf="showLoadingMsg" class="transition-card__body-text">
                    Uploading ...
                </p>
                <p *ngIf="showEditCTA" class="transition-card__body-text">
                <br />
                    Need to change something?
                    <span class="transition-card__link-text--plain" (click)="cancelAndReapply()">Edit Application</span>
                </p>
            </div>
            <div class="button-container">
                <p *ngIf="showChatCTA">
                    <button class="button button--yellow button--primary" (click)="openMessenger()"> Chat </button>
                </p>
                <p *ngIf="showAddFileCTA">
                    <button class="button button--yellow button--primary" (click)="uploadDocument()"> Add Files </button>
                </p>
                <p *ngIf="showExitCTA" class="transition-card__body-text">
                    <button routerLink="account-center" class="button button--blue button--primary">EXIT</button>
                </p>
            </div>
            <div class="transition-card__footer">
                <ng-container *ngIf="showReapplyCTA">
                    <p class="transition-card__footer-text">You can
                        <button class="text-link text-link--secondary text-link--white">
                        <span class="transition-card__link-text" (click)="reapply()" >resubmit</span></button>
                        to make changes and submit your application again. All of your previous answers will be saved.
                    </p>
                </ng-container>
            </div>
        </section>
    </div>
</div>
<div *ngIf="showInsuredConsentMock()" class="autofill-coin" (click)="mockInsuredConsent()">
    <img class="autofill-coin__image" src="https://i.imgur.com/5CDWHju.png" />
</div>